import React from 'react';
import { useAtom } from 'jotai';

import {
  adminLoginInfoAtom,
  KioskStatus,
  kioskStatusAtom,
  modalInfoAtom,
} from 'store/globalStateAtom';
import { convertErrorCode } from 'utils';
import errorIcon from 'images/common/error_round.png';
import checkRoundIcon from 'images/common/check_round.png';
import checkIcon from 'images/common/check.png';
import resetIcon from 'images/common/reset_white.png';
import playIcon from 'images/common/play.png';

type Props = {
  resetKiosk: () => void;
};
function ErrorStatus({ resetKiosk }: Props) {
  const [kioskStatus] = useAtom(kioskStatusAtom);
  const [adminLoginInfo] = useAtom(adminLoginInfoAtom);
  const [, setModalInfo] = useAtom(modalInfoAtom);
  const { bd1ErrorCode, bd2ErrorCode, bd1Error, bd2Error, hp1Error } =
    kioskStatus as KioskStatus;
  const haveAnyErrors = Boolean(bd1Error || bd2Error || hp1Error);
  const { code, message } = convertErrorCode(
    bd1Error ? bd1ErrorCode : bd2Error ? bd2ErrorCode : 0,
  );

  const openErrorHelpVideo = () => {
    setModalInfo({
      icon: 'RESET',
      description: `영상에 따라 조치 후 상태확인을 통해 키오스크 상태를 확인해주세요.`,
      btnText: '닫기',
      btnClass:
        'bg-mono-10 text-mono-80 active:bg-mono-20 w-[240px] text-white', // 왼쪽 버튼
      btnCallback: () => {},
      subBtnText: '상태확인',
      subBtnClass:
        'bg-blue-100 text-white active:bg-blue-150 flex justify-center items-center gap-2 w-[502px]', // 오른쪽 버튼
      subBtnCallback: () => {
        resetKiosk();
      },
      videoUrl:
        'https://ktp-image.s3.ap-northeast-2.amazonaws.com/ktpKiosk/video/kiosk-error-handling.mp4',
    });
  };

  return (
    <>
      <div className='flex gap-6 items-center mt-12 mb-6 '>
        <h3 className='text-head-02 font-semibold text-mono-80'>
          키오스크 상태
        </h3>
        {haveAnyErrors && (
          <span className='text-warning-100 text-head-02 font-semibold'>
            {hp1Error ? '에러 코드 ER10' : code}
          </span>
        )}
      </div>
      <div className='flex gap-3 items-start'>
        <img
          src={haveAnyErrors ? errorIcon : checkRoundIcon}
          className='w-9 h-9 mt-1'
          alt='kiosk_status'
        />
        <p className='text-body-01 font-semibold text-mono-80'>
          {haveAnyErrors
            ? hp1Error
              ? '동전 방출기 에러입니다. 동전 방출기를 확인해주세요.'
              : message +
                `\n(${bd1Error ? '천원권' : '만원권'} 지폐 방출기 확인)`
            : '키오스크 상태가 정상입니다.'}
        </p>
      </div>
      {Boolean(['ER06', 'ER07'].includes(code) && !adminLoginInfo.isManager) ? (
        <></>
      ) : (
        <div className='flex justify-center gap-10'>
          <button
            className='rounded-100 bg-blue-100 py-5 px-44 flex text-white text-body-01 font-semibold items-center gap-2 mt-20 active:bg-blue-150 disabled:bg-blue-20'
            onClick={resetKiosk}
            disabled={!haveAnyErrors}
          >
            <img
              src={haveAnyErrors ? resetIcon : checkIcon}
              className='w-9 h-9'
              alt='reset'
            />
            {haveAnyErrors ? '상태 확인' : '상태 정상'}
          </button>
          {haveAnyErrors && (
            <button
              className='rounded-100 bg-mono-35 py-5 px-16 flex text-white text-body-01 font-semibold items-center gap-2 mt-20 active:bg-gray-500'
              onClick={openErrorHelpVideo}
            >
              <img src={playIcon} className='w-9 h-9' alt='reset' />
              해결 영상
            </button>
          )}
        </div>
      )}
    </>
  );
}

export default ErrorStatus;
